export const VOLUNTARY_CHANGE_FEATURE_KEY = 'voluntary-change';

export const ORDER_ID_QUERY_PARAM = 'orderid';
export const HASH_QUERY_PARAM = 'hash';
